import { RequestsEnum } from './enum';

import { GENERATE_AVAILABILITY_REPORT } from '../orders/downloadOrderDetailsReport/actions';

export const requests = (state = [], action) => {
  switch (action.type) {
    case 'CLEAR_INVITATION_ERROR': {
      return state.filter(request => request.name !== 'ISSUE_INVITATION');
    }
    case 'CLEAR_UPDATE_USER_ERROR': {
      return state.filter(request => request.name !== 'UPDATE_USER' && request.name !== 'TOGGLE_USER_STATUS');
    }
    case 'CLEAR_ORDER_DETAILS_REPORT_ERROR': {
      return state.filter(request => request.name !== GENERATE_AVAILABILITY_REPORT);
    }
    case RequestsEnum.REQUEST_STARTED: {
      return [...state, action.payload];
    }
    case RequestsEnum.REQUEST_FAILED:
    case RequestsEnum.REQUEST_SUCCESS: {
      return state.map(request => (request.name === action.payload.name ? action.payload : request));
    }
    case RequestsEnum.REQUEST_FINISHED: {
      return state.filter(request => request.name !== action.payload.name);
    }
    default:
      return state;
  }
};

export const requestsSelectors = {
  getInvitationsInProgress: state =>
    state.requests.some(request => request.name === 'GET_INVITATIONS' && request.started),
  invitationError: state => state.requests.some(request => request.name === 'ISSUE_INVITATION' && request.error),
  invitationInProgress: state => state.requests.some(request => request.name === 'ISSUE_INVITATION' && request.started),
  invitationSuccess: state => state.requests.some(request => request.name === 'ISSUE_INVITATION' && request.success),
  loadInitialUsersInProgress: state =>
    state.requests.some(request => request.name === 'LOAD_INITIAL_USERS' && request.started),
  loadInitialDeactivatedUsersInProgress: state =>
    state.requests.some(request => request.name === 'LOAD_INITIAL_DEACTIVATED_USERS' && request.started),
  searchSortUsersInProgress: state =>
    state.requests.some(request => request.name === 'SEARCH_SORT_USERS' && request.started),
  searchUsersInProgress: state => state.requests.some(request => request.name === 'SEARCH_USERS' && request.started),
  updateUserError: state =>
    state.requests.some(
      request => (request.name === 'UPDATE_USER' || request.name === 'TOGGLE_USER_STATUS') && request.error
    ),
  updateUserInProgress: state => state.requests.some(request => request.name === 'UPDATE_USER' && request.started),
  updateUserSuccess: state => state.requests.some(request => request.name === 'UPDATE_USER' && request.success),
  toggleUserStatusInProgress: state =>
    state.requests.some(request => request.name === 'TOGGLE_USER_STATUS' && request.started)
};
